import { TApplicationState } from '../../types/redux';

export const selectFormPhoneVerificationCode = (state: TApplicationState) => state.requestFormV2.phoneVerification.code;
